"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsProductAPISearchDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const types_1 = require("../../types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-product-api-search-data">
    ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.productAPISearchData) === null || _a === void 0 ? void 0 : _a.operation) === 'searchProducts'; }, (0, fast_element_1.html) `
        ${(0, fast_element_1.when)(x => { var _a; return (_a = x.productAPISearchData) === null || _a === void 0 ? void 0 : _a.searchQuery; }, (0, fast_element_1.html) `
            <div class="search-query">
                <span class="query-label">${'productAPISearch.searchQuery'.t()}:</span>
                <span class="query-text">"${x => x.productAPISearchData.searchQuery}"</span>
            </div>
        `)}
        ${(0, fast_element_1.when)(x => { var _a; return (_a = x.productAPISearchData) === null || _a === void 0 ? void 0 : _a.totalResults; }, (0, fast_element_1.html) `
            <div class="results-summary">
                <span class="results-count">${x => x.productAPISearchData.totalResults} ${'productAPISearch.totalResults'.t()}</span>
            </div>
        `)}
        ${(0, fast_element_1.when)(x => { var _a, _b; return ((_b = (_a = x.productAPISearchData) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.length) > 0; }, (0, fast_element_1.html) `
            <div class="products-list">
                ${(0, fast_element_1.repeat)(x => x.productAPISearchData.products, (0, fast_element_1.html) `
                    <div class="product-item" @click="${(p, c) => c.parent.openLink(p.url)}">
                        ${(0, fast_element_1.when)(p => p.imageUrl, (0, fast_element_1.html) `
                            <div class="product-image-wrap">
                                <img :src="${p => p.imageUrl}" :alt="${p => p.name}" loading="lazy" />
                            </div>
                        `)}
                        <div class="product-info">
                            <div class="product-name">${p => p.name}</div>
                            ${(0, fast_element_1.when)(p => p.description, (0, fast_element_1.html) `
                                <div class="product-desc">${p => p.description}</div>
                            `)}
                            <div class="product-price">
                                ${(p, c) => { var _a; return c.parent.formatPrice((_a = p.prices) === null || _a === void 0 ? void 0 : _a.gross); }}€
                            </div>
                        </div>
                    </div>
                `)}
            </div>
        `)}
    `)}

    ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.productAPISearchData) === null || _a === void 0 ? void 0 : _a.operation) === 'getCategories'; }, (0, fast_element_1.html) `
        ${(0, fast_element_1.when)(x => { var _a, _b; return ((_b = (_a = x.productAPISearchData) === null || _a === void 0 ? void 0 : _a.categories) === null || _b === void 0 ? void 0 : _b.length) > 0; }, (0, fast_element_1.html) `
            <div class="categories-list">
                ${(0, fast_element_1.repeat)(x => x.productAPISearchData.categories, (0, fast_element_1.html) `
                    <div class="category-item" @click="${(cat, c) => c.parent.openLink(cat.url)}">
                        <span class="category-name">${cat => cat.name}</span>
                        <span class="category-id">ID: ${cat => cat.id}</span>
                        ${(0, fast_element_1.when)(cat => { var _a; return ((_a = cat.subcategories) === null || _a === void 0 ? void 0 : _a.length) > 0; }, (0, fast_element_1.html) `
                            <span class="subcategory-count">(${cat => cat.subcategories.length} ${'productAPISearch.subcategories'.t()})</span>
                        `)}
                    </div>
                `)}
            </div>
        `)}
    `)}

    ${(0, fast_element_1.when)(x => { var _a, _b, _c, _d; return !((_b = (_a = x.productAPISearchData) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.length) && !((_d = (_c = x.productAPISearchData) === null || _c === void 0 ? void 0 : _c.categories) === null || _d === void 0 ? void 0 : _d.length); }, (0, fast_element_1.html) `
        <div class="empty-state">
            <span class="empty-icon">🔍</span>
            <p>${'productAPISearch.noResults'.t()}</p>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-product-api-search-data {
  border-radius: 12px;
}
.rws-tools-product-api-search-data .search-query {
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
  padding: 12px 16px;
  border-left: 4px solid var(--primary-color, #007acc);
  margin-bottom: 16px;
}
.rws-tools-product-api-search-data .search-query .query-label {
  font-weight: 600;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  margin-right: 8px;
}
.rws-tools-product-api-search-data .search-query .query-text {
  color: var(--text-primary, #1a1a1a);
  font-weight: 500;
  font-family: monospace;
  background: var(--bg-tertiary, #ffffff);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid var(--border-color-light, #dee2e6);
}
.rws-tools-product-api-search-data .results-summary {
  background: var(--success-color-light, #d4edda);
  border: 1px solid var(--success-color, #28a745);
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 16px;
}
.rws-tools-product-api-search-data .results-summary .results-count {
  color: var(--success-color-dark, #155724);
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 6px;
}
.rws-tools-product-api-search-data .products-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
  gap: 10px;
  max-height: 400px;
  overflow-y: auto;
}
.rws-tools-product-api-search-data .products-list .product-item {
  background: var(--bg-tertiary, #ffffff);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.rws-tools-product-api-search-data .products-list .product-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: var(--primary-color, #007acc);
}
.rws-tools-product-api-search-data .products-list .product-item:hover::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--primary-color, #007acc);
}
.rws-tools-product-api-search-data .products-list .product-item {
  padding: 12px;
  gap: 12px;
}
.rws-tools-product-api-search-data .products-list .product-item .product-image-wrap {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  background: var(--bg-light, #f8f9fa);
}
.rws-tools-product-api-search-data .products-list .product-item .product-image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.rws-tools-product-api-search-data .products-list .product-item .product-info {
  flex: 1;
  min-width: 0;
}
.rws-tools-product-api-search-data .products-list .product-item .product-info .product-name {
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  font-size: 0.9rem;
  margin-bottom: 2px;
}
.rws-tools-product-api-search-data .products-list .product-item .product-info .product-desc {
  font-size: 0.8rem;
  color: var(--text-secondary, #6c757d);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rws-tools-product-api-search-data .products-list .product-item .product-info .product-price {
  font-weight: 700;
  color: var(--primary-color, #007acc);
  font-size: 0.95rem;
  margin-top: 4px;
}
.rws-tools-product-api-search-data .categories-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
  gap: 6px;
}
.rws-tools-product-api-search-data .categories-list .category-item {
  background: var(--bg-tertiary, #ffffff);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.rws-tools-product-api-search-data .categories-list .category-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: var(--primary-color, #007acc);
}
.rws-tools-product-api-search-data .categories-list .category-item:hover::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--primary-color, #007acc);
}
.rws-tools-product-api-search-data .categories-list .category-item {
  padding: 10px 14px;
}
.rws-tools-product-api-search-data .categories-list .category-item .category-name {
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  flex: 1;
}
.rws-tools-product-api-search-data .categories-list .category-item .category-id {
  font-size: 0.8rem;
  color: var(--text-tertiary, #9ca3af);
  font-family: monospace;
}
.rws-tools-product-api-search-data .categories-list .category-item .subcategory-count {
  font-size: 0.8rem;
  color: var(--text-secondary, #6c757d);
  margin-left: 8px;
}
.rws-tools-product-api-search-data .empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-product-api-search-data .empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}
.rws-tools-product-api-search-data .empty-state p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.rws-tools-product-api-search-data .empty-state .empty-suggestion {
  color: var(--text-tertiary, #9ca3af);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 8px;
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-container {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-list-item {
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-list-item .item-title {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-list-item .item-subtitle {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-list-item .item-description {
  color: var(--text-secondary-dark, #a0aec0);
  border-top-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-list-item:hover {
  background: var(--bg-hover-dark, #4a5568);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-list-item:hover::after {
  background: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-query-display {
  background: var(--bg-secondary-dark, #2d3748);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-query-display .query-label {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-query-display .query-text {
  color: var(--text-primary-dark, #f7fafc);
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-results-summary {
  background: var(--success-color-dark-bg, #1e4d2b);
  border-color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-results-summary .results-count {
  color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-empty-state p {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-empty-state .empty-suggestion {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-loading-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-product-api-search-data .tool-loading-state .spinner {
  border-color: var(--border-color-dark, #4a5568);
  border-top-color: var(--primary-color-dark, #63b3ed);
}
@media (max-width: 768px) {
  .rws-tools-product-api-search-data {
    padding: 16px;
    margin: 12px 0;
  }
  .rws-tools-product-api-search-data h3 {
    font-size: 1.1rem;
  }
  .rws-tools-product-api-search-data h4 {
    font-size: 0.95rem;
  }
  .rws-tools-product-api-search-data .tool-container {
    padding: 12px;
  }
  .rws-tools-product-api-search-data .tool-list-item {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .rws-tools-product-api-search-data .tool-list-item .item-title {
    font-size: 0.9rem;
  }
  .rws-tools-product-api-search-data .tool-list-item .item-description {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .rws-tools-product-api-search-data .tool-empty-state {
    padding: 24px 12px;
  }
  .rws-tools-product-api-search-data .tool-empty-state .empty-icon {
    font-size: 2rem;
  }
  .rws-tools-product-api-search-data .tool-empty-state p {
    font-size: 0.9rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsProductAPISearchDataComponent = class RWSToolsProductAPISearchDataComponent extends client_1.RWSViewComponent {
    formatPrice(price) {
        return (price === null || price === void 0 ? void 0 : price.toFixed(2)) || '0.00';
    }
    openLink(url) {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }
};
exports.RWSToolsProductAPISearchDataComponent = RWSToolsProductAPISearchDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof types_1.ProductAPISearchData !== "undefined" && types_1.ProductAPISearchData) === "function" ? _a : Object)
], RWSToolsProductAPISearchDataComponent.prototype, "productAPISearchData", void 0);
exports.RWSToolsProductAPISearchDataComponent = RWSToolsProductAPISearchDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-product-api-search-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsProductAPISearchDataComponent);
RWSToolsProductAPISearchDataComponent.defineComponent();
